import { ReactElement } from "react";
import { cn } from "@util/helpers";

export type SummaryProps = {
  rootClassName?: string;
  summary?: string;
};

/**
 * Summary
 * Description: The summary of the article
 * @param {SummaryProps} props
 * @returns {ReactElement}
 */
export default function Summary({
  rootClassName = "",
  summary = "",
}: SummaryProps): ReactElement {
  return <p className={cn("max-lg:hidden", rootClassName)}>{summary}</p>;
}
